import GameManager from './controllers/GameManager.js';
import { getElem, getViewportSize, logEvent, toggleBottomLogo } from './utils/index';
import { config } from './utils/settings.js';
import HTML_Splash from './_html/HTML_Splash.js';
import { loader } from './utils/assetLoader.js';
import HTML_Desktop from './_html/HTML_Desktop.js';
import { ISO, translateHTML } from './localiser/locale.js';
import { langsList } from './localiser/translations.js';

const setupPixi = () => {
    // Initial background color depends on whether we expect camera to work
    const isMobileSafari = /iPhone|iPad|iPod/i.test(navigator.userAgent) && 
                        /WebKit/i.test(navigator.userAgent) && 
                        !/CriOS|FxiOS/i.test(navigator.userAgent);
    
    // Some browsers/contexts restrict camera - set a fallback background
    const shouldFallbackToSkyBg = 
        !window.isSecureContext || 
        isMobileSafari ||
        location.protocol !== 'https:';
    
    let app = new PIXI.Application({
        width: config.width,
        height: config.height,
        backgroundColor: 0x000000,
        backgroundAlpha: 0,
        antialias: true,
        resolution: window.devicePixelRatio,
        autoDensity: true,
    });
    
    getElem('game-container').appendChild(app.view);

    // Make sure canvas is properly sized
    app.view.style.position = 'absolute';
    app.view.style.top = '0';
    app.view.style.left = '0';
    app.view.style.width = '100svw';
    app.view.style.height = '100svh';

    return app;
}

const registerAnalytics = () => {
    getElem('nestleLink').addEventListener("pointerup", () => {
        logEvent("nestle_cereals_click");
    })

    getElem('splash-page-privacy').addEventListener("pointerup", () => {
        logEvent("privacy_button_click");
    })

    getElem('splash-page-cookies').addEventListener("pointerup", () => {
        logEvent("cookies_button_click");
    })
}

window.gameStarted = false;
let gameManager;

let forceMobile = false;
const isMobileDevice = () => {
    console.log("Testing if mobile device");
    const userAgent = navigator.userAgent || navigator.vendor;
    const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|silk/i;
    return forceMobile ? forceMobile : mobileRegex.test(userAgent);
}

async function lockOrientation() {
    try {
        if (screen.orientation && screen.orientation.lock) {
            await screen.orientation.lock("portrait");
            console.log("Orientation locked to portrait");
        } else {
            console.log("Screen Orientation API not supported");
        }
    } catch (error) {
        console.error("Failed to lock orientation:", error);
    }
}

window.addEventListener('load', async () => {

    translateHTML();

    const log = getElem("log");
    let index = 0;
    log.addEventListener("pointerdown", () => {
        console.log("iterate language");
        index = langsList.indexOf(ISO);
        index++;
        translateHTML(langsList[index % (langsList.length)]);
    })

    lockOrientation();
    await loader.preload();

    // const bgm = loader.Sound("fast-tribal-drums");
    // bgm.loop = true;
    // bgm.play();
    registerAnalytics();
    if(isMobileDevice()) {
        // mobile
        getElem("rotate-prompt").style.width = "100%";
        getElem("rotate-prompt").style.height = "100%";
        let app = setupPixi();
        
        gameManager = new GameManager(config, app);
        let html_splash = new HTML_Splash();
        await html_splash.splashCheck();
        gameManager.initCam();
        html_splash.hideSplashPage();
        gameManager.initMic().then(success => {
            if (success) {
                gameManager.playTutorial();
            } else {
                console.error('Failed to initialize game');
            }
        });
    } else {
        registerAnalytics();
        getElem('game-container').style.display = "none";
        let html_desktop = new HTML_Desktop();
        html_desktop.show();
        // desktop
    }
});

// Handle window resize
// window.addEventListener('resize', () => {
//     if (gameManager) {
//         const newSize = getViewportSize();
//         gameManager.handleResize(newSize.width, newSize.height);
//     }
// });

// Handle page unload to clean up resources
window.addEventListener('beforeunload', () => {
    if (gameManager) {
        gameManager.cleanup();
    }
});

